// src/components/UI/TutorialIntroModal.js
import React from 'react';
import { createPortal } from 'react-dom';
import styles from './TutorialIntroModal.module.css';

const Illustration = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 328 327"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="63.3832"
      y="100.191"
      width="180.631"
      height="135.333"
      rx="18.7943"
      transform="rotate(-10.3608 63.3832 100.191)"
      fill="white"
    />
    <rect
      x="63.3832"
      y="100.191"
      width="180.631"
      height="135.333"
      rx="18.7943"
      transform="rotate(-10.3608 63.3832 100.191)"
      stroke="#D0E7FF"
      strokeWidth="1.21253"
    />
    <g filter="url(#tut-intro-shadow)">
      <g clipPath="url(#tut-intro-clip)">
        <rect
          x="90.396"
          y="85.1819"
          width="114.886"
          height="154.846"
          rx="9.99005"
          transform="rotate(-13.1732 90.396 85.1819)"
          fill="white"
        />
        <rect
          x="99.3984"
          y="90.7698"
          width="99.9005"
          height="69.9303"
          rx="4.99502"
          transform="rotate(-13.1732 99.3984 90.7698)"
          fill="#E5EDF3"
        />
        <rect
          x="118.181"
          y="171.019"
          width="99.9005"
          height="4.33504"
          rx="2.16752"
          transform="rotate(-13.1732 118.181 171.019)"
          fill="#E5EDF3"
        />
        <rect
          x="121.009"
          y="183.1"
          width="64.9772"
          height="4.33504"
          rx="2.16752"
          transform="rotate(-13.1732 121.009 183.1)"
          fill="#E5EDF3"
        />
        <rect
          x="123.836"
          y="195.18"
          width="89.7029"
          height="4.33504"
          rx="2.16752"
          transform="rotate(-13.1732 123.836 195.18)"
          fill="#E5EDF3"
        />
      </g>
      <rect
        x="90.7711"
        y="85.4147"
        width="114.261"
        height="154.221"
        rx="9.67786"
        transform="rotate(-13.1732 90.7711 85.4147)"
        stroke="#D0E7FF"
        strokeWidth="0.624378"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M252.462 206.334C254.253 206.054 254.708 203.684 253.147 202.762L225.085 186.18C223.652 185.333 221.891 186.574 222.205 188.208L228.584 221.378C228.938 223.219 231.442 223.528 232.233 221.828L237.986 209.461C238.258 208.877 238.803 208.466 239.44 208.367L252.462 206.334Z"
      fill="white"
      stroke="#ACCCEF"
      strokeWidth="3.86377"
      strokeLinecap="square"
    />
    <defs>
      <filter
        id="tut-intro-shadow"
        x="-2.01195"
        y="-33.4079"
        width="331.967"
        height="361.769"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="8.74129" operator="dilate" in="SourceAlpha" result="effect1_dropShadow" />
        <feOffset />
        <feGaussianBlur stdDeviation="41.8333" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.470588 0 0 0 0 0.701961 0 0 0 0 0.952941 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <clipPath id="tut-intro-clip">
        <rect
          x="90.396"
          y="85.1819"
          width="114.886"
          height="154.846"
          rx="9.99005"
          transform="rotate(-13.1732 90.396 85.1819)"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

const TutorialIntroModal = ({ open, onStart, onClose }) => {
  if (!open) return null;
  return createPortal(
    <div className={styles.backdrop} role="dialog" aria-modal="true" aria-labelledby="tut-intro-title">
      <div className={styles.modal}>
        <button type="button" className={styles.close} onClick={onClose} aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
        <div className={styles.illustration}>
          <Illustration />
        </div>
        <div className={styles.content}>
          <h2 id="tut-intro-title" className={styles.title}>Create Your Product Content in Under 2 Minutes</h2>
          <p className={styles.body}>Follow our quick tutorial to get started</p>
          <p className={styles.body}>
            We&apos;re fetching your Amazon catalogue in the background. In the meantime, walk through this quick tutorial to see how to refresh an existing listing.
          </p>
          <button type="button" className={styles.startButton} onClick={onStart}>
            Start Tutorial
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TutorialIntroModal;
